<template>
	<div class="layout-footer" >
        <p>© สำนักป้องกันและบรรเทาสาธารณภัย กรุงเทพมหานคร 77/1 ถนนพระรามที่ 6 แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 10400 โทรศัพท์ 023546858 (เบอร์กลาง) โทรสาร 023546842 
			&nbsp; <i class="pi pi-phone"></i> สายด่วน 199</p>
		
          
        
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>
@media screen and (max-width: 420px){
.layout-footer{
font-size: 11px;
}

}

	

</style>
